// iter-386u-bw — Universal credit-cost badge.
// Usage: <CreditBadge toolKey="ai_task_creator" />
// Reads live from useAICredits() so any admin edit in the SaaS Manager
// propagates without a redeploy or hard refresh.
import { useAICredits } from '@/hooks/useAICredits';
import { Sparkles } from 'lucide-react';

export function CreditBadge({ toolKey, className = '', variant = 'default' }) {
  const { costFor } = useAICredits();
  const cost = costFor(toolKey);
  if (!cost || cost <= 0) return null;
  const base = 'inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-bold tracking-tight border';
  const tone = variant === 'onDark'
    ? 'bg-amber-400/20 text-amber-100 border-amber-300/40'
    : 'bg-amber-50 text-amber-800 border-amber-200';
  return (
    <span
      className={`${base} ${tone} ${className}`}
      data-testid={`credit-badge-${toolKey}`}
      title={`Costs ${cost} credit${cost === 1 ? '' : 's'} per call`}
    >
      <Sparkles size={9} strokeWidth={2.5} />
      {cost}
    </span>
  );
}

export default CreditBadge;
